export default __webpack_public_path__ + "static/media/logo-white.bfc601ae.svg";